export interface SwitchableComponent {
    component: any; //ComponentType<any>
    events: { emitter: string; switchToIndex: number }[];
    isVisible: boolean;
    props?: {name: string, value: any}[];
  }